import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCheck } from "@fortawesome/pro-regular-svg-icons";
import { TaskItem } from "../task-item";
/** A labelled group of task items with a count badge and empty-state placeholder. */
export function TaskSection(_ref) {
  var title = _ref.title,
    count = _ref.count,
    emptyMessage = _ref.emptyMessage,
    reminders = _ref.reminders,
    onSelect = _ref.onSelect;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 py-2 sticky top-0 bg-sds-base-default z-sds-25"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-caps text-sds-base-tertiary"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-strong rounded-sds-full bg-sds-base-secondary text-sds-base-tertiary px-2 py-1 ml-1"
  }, count)), reminders.length > 0 ? reminders.map(function (reminder) {
    return /*#__PURE__*/React.createElement(TaskItem, _extends({
      key: reminder.id,
      reminder: reminder
    }, onSelect && {
      onSelect: onSelect
    }));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-2 py-6 rounded-sds-300 border border-dashed border-sds-base-default"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSquareCheck,
    className: "w-5 h-5 text-sds-base-tertiary"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-style-label-base text-sds-base-tertiary"
  }, emptyMessage)));
}